import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const ResultsPlaceholder: React.FC = () => (
  <Box
    sx={{
      background: 'var(--Background-200, var(--bg-colors))',
      border: '1px dashed var(--filter-selected)',
      borderRadius: '12px',
      minHeight: 220,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1.5,
      px: 3,
      py: 4,
      color: 'var(--Text-Main, var(--text-primary))',
    }}
  >
    <InfoOutlinedIcon sx={{ color: 'var(--action-color)' }} />
    <Typography
      sx={{
        color: 'var(--card-text)',
        fontFamily: 'Inter',
        fontSize: 14,
        fontWeight: 500,
      }}
    >
      Please Fill the Required Information Above
    </Typography>
  </Box>
);
